module.exports = __webpack_public_path__ + "img/product5-2.a4936e6a.jpg";